<template>
    <div
        class="product-box-wrapper"
        @mouseover="displayWishlistButton = true"
        @mouseleave="displayWishlistButton = false"
    >
        <wishlist-button
            class="wishlist-button-tooltip"
            :productId="product.id"
            buttonColor="light"
            :show-button="displayWishlistButton"
        />
        <v-chip
            v-if="priceData.original_price_inkl_vat > priceData.price"
            label
            color="primary"
            text-color="white"
            class="discount-badge"
        >-{{ discountRate }}%</v-chip>
        <v-card
            class="product-box"
            hover
            :to="getProductUrl(product)"
        >
            <v-img
                :aspect-ratio="$vuetify.breakpoint.smAndDown ? 1/1 : 3/4"
                :lazy-src="product.images.default.placeholder"
                :src="product.images.default.medium"
                contain
            >
                <v-layout
                    column
                    fill-height
                    ma-0
                    class="white--text"
                >
                    <v-spacer></v-spacer>
                    <v-flex shrink pa-0>
                        <v-card-title>
                            <div>
                                <div class="headline font-weight-light">{{ title }}</div>
                                <div class="caption font-weight-medium text-uppercase">
                                    {{description | striphtml}}
                                </div>
                                <v-rating
                                    background-color="white"
                                    color="white"
                                    dense
                                    half-increments
                                    readonly
                                    small
                                    :value="product.rating"
                                    v-if="product.reviewCount"
                                ></v-rating>
                            </div>
                        </v-card-title>
                    </v-flex>
                </v-layout>
            </v-img>
            <v-card-actions>
                <template v-if="pricesAreDifferent">
                    <span class="headline mr-1">
                        {{ 'Jetzt ab' | translation }}
                    </span>
                </template>
                <template v-if="priceData.original_price_inkl_vat > priceData.price">
                    <span class="headline light--text text--darken-4">
                        <del>{{priceData.original_price_inkl_vat | currency}}</del>&nbsp;
                    </span>
                    <span class="headline">
                        {{priceData.price | currency}}
                    </span>
                </template>
                <template v-else>
                    <span class="headline">
                        {{priceData.price | currency}}
                    </span>
                </template>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { eventManager } from '@breakmedia/prime-vue-event-manager';

const moduleName = 'ProductThumbnail';

export default {
    name: moduleName,
    props: [
        'product',
        'target',
    ],
    data() {
        return {
            displayWishlistButton: false,
        };
    },
    methods: {
        getProductUrl(product) {
            return this.$product.getProductRouteConfig(product);
        },
    },
    created() {
        eventManager.$emit('productPreview', this.product, this.target);
    },
    computed: {
        title() {
            return this.getProductAttributeByLanguage(this.product, 'product.name');
        },
        description() {
            let description = this.getProductAttributeByLanguage(this.product, 'product.description.short');
            if (description && description.length === 0) {
                description = this.getProductAttributeByLanguage(this.product, 'product.description.long');
            }
            return description;
        },
        ...mapGetters('Product', [
            'getProductAttributeByLanguage',
            'getDiscountRate',
        ]),
        priceData() {
            return this.product.price || {};
        },
        pricesAreDifferent() {
            const priceData = this.priceData;
            return priceData.hasOwnProperty('is_start_from') && priceData.is_start_from === true;
        },
        discountRate() {
            return this.getDiscountRate(this.priceData);
        },
    },

};
</script>

<style>
    .discount-badge {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1;
    }
</style>
